const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/ledger/v1backend/creditdg/search', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
